import { render } from "./WCRandomWeightModal.vue?vue&type=template&id=88efad22&scoped=true&ts=true"
import script from "./WCRandomWeightModal.vue?vue&type=script&lang=ts"
export * from "./WCRandomWeightModal.vue?vue&type=script&lang=ts"

import "./WCRandomWeightModal.vue?vue&type=style&index=0&id=88efad22&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-88efad22"]])

export default __exports__